// Run tasks, when connectivity is lost/resumed.
import { useEffect, useMemo } from 'react';
import { getCsrfToken } from '@/httpClient/requests/getCsrfToken.ts';

const logOnline = () => {
  console.debug('Device gained network connection, now online.');
};

const logOffline = () => {
  console.debug('Device lost network connection, now offline.');
};

export const OnlineHookProvider = () => {
  // Tasks for when going online
  const goingOnline = useMemo(() => [logOnline, getCsrfToken], []);

  // Tasks for when connectivity is lost
  const goingOffline = useMemo(() => [logOffline], []);

  useEffect(() => {
    const workOnlineTasks = async () => {
      for (const task of goingOnline) {
        await task();
      }
    };
    window.addEventListener('online', workOnlineTasks);

    return () => {
      window.removeEventListener('online', workOnlineTasks);
    };
  }, [goingOnline]);

  useEffect(() => {
    const workOfflineTasks = async () => {
      for (const task of goingOffline) {
        await task();
      }
    };
    window.addEventListener('offline', workOfflineTasks);

    return () => {
      window.removeEventListener('offline', workOfflineTasks);
    };
  }, [goingOffline]);

  return null;
};
